import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { parseFrontendEnvironment } from './config/environment';
import './styles/global.css';

const rootElement = document.querySelector<HTMLDivElement>('#root');

if (rootElement === null) {
  throw new Error('Missing application root element.');
}

const environment = parseFrontendEnvironment(import.meta.env);

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <App environment={environment} />
    </AppErrorBoundary>
  </StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js', { scope: '/' });
}
